export default {
    index:{
        pageTitle:'USB Custom Keyboard Configuration Tool',
        more:'More',
        about:'About',
        aboutBuildTime:'Program build time: ',
        factoryTest:'Factory Test',
        readStatus:'Read status',
        autoRefresh:'Auto refresh 0.5s',
        factoryLedTip:'Observe the keyboard LEDs: normally red/green should alternate slowly every 0.5 s. If one LED is off, check the corresponding LED.',
        factoryAbnormal:'Abnormal: no IO connection detected (no key / no USB / no charging / battery below 2V)',
        factoryPassPrefix:'Passed: all ',
        factoryPassSuffix:' keys pressed, battery OK',
        factoryItem:'Item',
        factoryValue:'Status',
        factoryResult:'Result',
        factoryPassShort:'Pass',
        factoryFailShort:'Fail',
        factoryWait:'Waiting',
        factoryNote:'Protocol: send 02 46, device returns FT1 status. Supports D2 BLE 2-key / D6 3-mode 6-key / D9 9-key firmware.',
        factoryKey:'Key ',
        factoryPressed:'Pressed',
        factoryReleased:'Released',
        factoryReleasedDetected:'Released (detected)',
        factoryBatteryAdc:'Battery ADC',
        factoryUsbVcc:'USB VCC pin',
        factoryUsbHigh:'High / USB present',
        factoryUsbLow:'Low / no USB',
        factoryCharging:'Charging',
        factoryNotCharging:'Not charging',
        factoryLedRed:'Red LED',
        factoryLedGreen:'Green LED',
        factoryOn:'On',
        factoryOff:'Off',
        factoryBle:'BLE connection',
        factoryConnected:'Connected',
        factoryDisconnected:'Disconnected',
        factoryRf24:'2.4G connection',
        factoryNotEnabled:'Not enabled',
        factoryPaRaw:'PA raw',
        factoryPbRaw:'PB raw',
        factoryMode:'Mode',
        schematicTitle:'Key layout',
        knobLabel:'Knob',
        firmware1:'Firmware 1',
        firmware2:'Firmware 2',
        firmware3:'Firmware 3',
        firmware4:'Firmware 4',
        videoTitle:'3-key video tutorial',
        videoUnsupported:'Your browser does not support video playback',
        connectionTip1:'Note: 3-mode wireless keyboard configuration requires connecting the keyboard with a USB cable. Select',
        connectionTip2:'or',
        connectionTip3:', do not select',
        connectionTip4:'(this is the receiver).',
        factoryConnectFirst:'Connect the device first',
        connecting:'Connecting to keyboard…',
        selectSerialPort:'Select the serial port and wait for the device to respond',
        errPageConfig:'The key configuration area for this model could not be created',
        errReplyTimeoutUnknown:'Device response timed out. Reconnect and retry; the save result is unknown.',
        errDisconnected:'Device disconnected',
        errEmptyReply:'Device returned an empty response',
        errReadbackMismatch:'Stored readback does not match the saved configuration; save cannot be confirmed.',
        errConfirmTimeout:'Timed out waiting for device confirmation. Reconnect and retry.',
        errNoAck:'No device confirmation received. Reconnect and retry.',
        errFactoryFormat:'Invalid factory test response: ',
        errNoResponse:'No response from device. Reconnect and retry.',
        back:'Back',
        loopInterval:'Loop Interval',
        helpTitle:'Help',
        helpTips0:'Introduction of 5 key modes:',
        helpTips1:'1.Common key:Define a key of the 3-key keyboard as a common key that can be input, such as 1, 2, 3, a, b, c, ?, space, etc.',
        helpTips1_1:'Note: If you input uppercase letters or !@#$% keys, it is actually triggered by Shift+corresponding keys!',
        helpTips2:'2.Function key:Define a key on the 3-key keyboard as a function key such as Ctrl, Alt, Win, Command, and Enter',
        helpTips2_1:'F13-F24 are special function keys, which are not available on ordinary keyboards, and can be used as custom shortcut keys in the software to prevent conflicts!',
        helpTips3:'3.Media key:Define a key on the 3-key keyboard as a media key such as volume up, brightness up, and open browser',
        helpTips4:'4.Combination key:Define a key on a 3-key keyboard as a combination of 2-5 keys, such as one-key Ctrl+c, one-key Win+l, one-key Ctrl+Alt+Delete, etc.',
        helpTips5:'5.String:Define a button of the 3-key keyboard as an input string, such as one-key input user name, one-key input select * from, etc.',
        helpTips6:'6.Mouse:Define a button of the 3-key keyboard as mouse button click, mouse movement, scroll wheel, etc.',
        helpButton:'Help',
        troubleshootTitle:'Keyboard not responding? Troubleshoot step by step',
        troubleshoot1:'Browser',
        troubleshoot1_desc:'Must use Chrome or Edge (version 103+), accessed via https or localhost; Safari and Firefox do not support serial ports and cannot connect.',
        troubleshoot2:'Access Method',
        troubleshoot2_desc:'Do not open the HTML file directly by double-clicking (file:// cannot use serial ports), please access via URL.',
        troubleshoot3:'"Connect" button does not pop up selection window',
        troubleshoot3_desc:'Most likely a USB cable issue — try a different cable (some cables only charge, not transfer data), try a different USB port, and plug directly into the host if possible, avoiding docking stations.',
        troubleshoot4:'Device not found in pop-up',
        troubleshoot4_desc:'Confirm the system has recognized the serial device (VID 0x1209 / PID 0xC550), then try reconnecting the keyboard.',
        troubleshoot5:'Port occupied, connection failed',
        troubleshoot5_desc:'Close programs that may occupy the serial port (serial assistant, Arduino IDE, other programming/key remapping tools) and try again.',
        troubleshoot6:'Connected successfully but cannot read configuration / firmware out of date',
        troubleshoot6_desc:'Update the firmware as prompted before configuring.',
        troubleshoot7:'Abnormal after multiple plug/unplug',
        troubleshoot7_desc:'Refresh the page (F5), reconnect the keyboard, and try again.',
        windowsTipsTitle:'Windows / Company Computer Tips',
        windowsTips1:'When the bottom-right shows "Unknown USB device", it means Windows failed to read device information — this is not a web configuration or browser issue; try a direct USB port, a known-good cable, and test on another computer.',
        windowsTips2:'If only the company computer cannot recognize it while other computers work fine, contact your IT department to check USB device control or whitelist; do not disable USB Root Hub or USB Controller system devices.',
        windowsTips3:'When "Unknown USB device" appears in Device Manager, right-click and select "Uninstall device" then reconnect; if the option "Delete the driver software for this device" appears, do NOT check it.',
        windowsTips4:'After saving parameters, it is recommended to reconnect the keyboard, then use an online keyboard tester to confirm the keys work as expected.',
        macTipsTitle:'Mac User Configuration Notes',
        macTips1:'Browser',
        macTips1_desc:'Use Mac version Chrome or Edge (103+), Safari does not support serial port connection.',
        macTips2:'Modifier Key Mapping',
        macTips2_desc:'Mac\'s Command (⌘) and Windows\' Win use the same keycode; select "Left Win/Command" when configuring.',
        macTips3:'Copy/Paste',
        macTips3_desc:'Windows uses Ctrl+C/V, Mac uses Command+C/V (in combination key mode, select "Left Win/Command" + c/v; there are also Mac presets in "Common Shortcuts").',
        macTips4:'Lock Screen',
        macTips4_desc:'Windows uses Win+L, Mac uses Control+Command+Q (see "Mac Lock Screen" in "Common Shortcuts").',
        macTips5:'Screenshot',
        macTips5_desc:'Windows uses Win+Shift+S, Mac uses Shift+Command+3/4 (see "Mac Quick Screenshot" in "Common Shortcuts").',
        macTips6:'First Connection',
        macTips6_desc:'A serial port authorization window will pop up on first connection; select the device and click Allow. If no pop-up appears, your browser version may be too old.',
        connButtonText1:'Connect Custom Keyboard',
        timerConfig:'Timer Trigger Configuration',
        triggerMode:'Trigger Mode',
        triggerModeManual:'Manual Trigger',
        triggerModeTimer:'Timer Trigger',
        triggerModeBoth:'Manual & Timer Trigger',
        hour:'Hour',
        minute:'Minute',
        second:'Second',
        keyAllLabel:'When the 3 keys are pressed at the same time, they act as an independent keys',
        keyAllTrue:'On',
        keyAllFalse:'Off',
        b3key1:'Key1',
        b3key2:'Key2',
        b3key3:'Key3',
        b3keyall:'All Keys',
        deviceTypeLabel:'Device Type',
        deviceVersionLabel:'Firmware Version',
        configSeqLabel:'Config Sequence',
        backlightTitle:'Backlight',
        backlightMode:'Mode',
        backlightMode0:'Off',
        backlightMode1:'Always On',
        backlightMode2:'Press On',
        backlightMode3:'Flowing',
        backlightMode4:'Breathing',
        backlightColor1:'LED 1 Color',
        backlightColor2:'LED 2 Color',
        backlightColor3:'LED 3 Color',
        backlightBrightness:'Brightness',
        colorBlue:'Blue',
        colorGreen:'Green',
        colorRed:'Red',
        colorYellow:'Yellow',
        colorCyan:'Cyan',
        colorPurple:'Purple',
        colorWhite:'White',
        keyTestLabel:'Keyboard Key Test Online',
        keyTestUrl:'https://keyboard.bmcx.com/',
        keyTestLabel2:'Online Keyboard Test',
        keyTestUrl2:'https://www.853295.com/',
        keyTestLabel3:'Mouse Button Test',
        keyTestUrl3:'https://cps-check.com/cn/mouse-buttons-test',
        keyTestLabel4:'Mouse Test Tool',
        keyTestUrl4:'https://www.mousetester.cn/',
        keyTestPrompt:'Click to go to online keyboard test website →',
        c4key1:'Key 1',
        c4key2:'Key 2',
        c4key3:'Key 3',
        c4key4:'Key 4',
        ec11Title:'Knob Settings',
        ec11CW:'CW Rotation',
        ec11CCW:'CCW Rotation',
        ec11Btn:'Button Press',
        ec11FuncKey:'Keyboard',
        ec11FuncMedia:'Media',
        ec11FuncMouse:'Mouse Click',
        ec11FuncFn:'Function Key',
        ec11FuncScroll:'Mouse Wheel',
        ec11FuncMix:'Combination Key',
        ec11ScrollUp:'Scroll Up',
        ec11ScrollDown:'Scroll Down',
        ec11KeyCode:'Key Code',
        ec11MouseLeft:'Left',
        ec11MouseMiddle:'Middle',
        ec11MouseRight:'Right',
        ec11ClickSingle:'Single Click',
        ec11ClickContinuous:'Continuous Click',
        ec11ClickPress:'Press',
        backlightColor4:'LED 4 Color',
        b6key1:'Key 1',
        b6key2:'Key 2',
        b6key3:'Key 3',
        b6key4:'Key 4',
        b6key5:'Key 5',
        b6key6:'Key 6',
        backlightColor5:'LED 5 Color',
        backlightColor6:'LED 6 Color',
        b4key1:'Key 1',
        b4key2:'Key 2',
        b4key3:'Key 3',
        b4key4:'Key 4',
        d2key1:'Key 1',
        d2key2:'Key 2',
        d2RunModeTitle:'Bluetooth Mode',
        d2RunMode:'Run Mode',
        d2RunModeKeyboard:'Keyboard Mode',
        d2RunModePage:'Page Mode',
        d2ModeTipKbd:'Keyboard Mode: ',
        d2ModeTipKbdDesc:'Both USB and Bluetooth work, can connect to a PC or phone as a standard keyboard;',
        d2ModeTipPage:'Page Mode: ',
        d2ModeTipPageDesc:'Mainly for Bluetooth connection to mobile devices for page-turning / swiping / media control.',
        d2PageAction:'Page Action',
        d2PagePrev:'Volume Keys',
        d2PageNext:'Left/Right Swipe',
        d2PagePlayPause:'Up/Down Scroll',
        d2PageHome:'Music Control',
        d2PageTableTitle:'Page Action Description',
        d2TableFirmware:'Firmware',
        d2TableFunction:'Function',
        d2TableScenario:'Usage Scenario',
        d2Firm1Func:'Volume Key Control',
        d2Firm1Scenario:'Turn pages on Android/HarmonyOS e-book readers (some apps require volume-key page-turn enabled), native camera photo/video capture',
        d2Firm2Func:'Horizontal Left/Right Swipe',
        d2Firm2Scenario:'iPhone novel page turn left/right, iPad landscape short-video swiping',
        d2Firm3Func:'Vertical Up/Down Swipe',
        d2Firm3Scenario:'Short-video scrolling (double-tap any key to pause playback); iPad landscape novel page turn',
        d2Firm4Func:'Music Playback Control',
        d2Firm4Scenario:'Prev/Next track in music player; double-tap any key to pause/resume music',
        d2NotesTitle:'Instructions & Notes',
        d2Note1:'iPhone users: enable Settings → Accessibility → Zoom. If the screen becomes abnormal, restore with a 3-finger double-tap.',
        d2Note2:'Yue Xing Tong users: scan QR code for dedicated mode usage.',
        d2Note3:'Some long-battery iReader semi-closed e-readers, iPhone WeChat Reading / Apple Books: scan QR code for alternate page mode usage.',
        e6ModeTitle:'Connection Mode',
        e6DeviceMode:'Mode',
        e6ModeBle:'Bluetooth Mode',
        e6ModeRf24:'2.4G Mode',
        e6ModeUsb:'USB Mode',
        e6ModeTip:'Tip: After selecting the connection mode, re-plug USB or restart the keyboard to take effect. Bluetooth is low-power wireless; 2.4G requires a 2.4G receiver; USB is wired.',
        e6key1:'Key 1',
        e6key2:'Key 2',
        e6key3:'Key 3',
        e6key4:'Key 4',
        e6key5:'Key 5',
        e6key6:'Key 6',
        d9key7:'Key 7',
        d9key8:'Key 8',
        d9key9:'Key 9',
        changeLog5:'2024.11.2 Updated to threekey_v7.0.hex Added press mouse when long press',
        changeLog4:'2024.7.12 Updated to threekey_v6.0.hex Added press enter after string input',
        changeLog3:'2023.6.16 Updated to threekey_v5.1.hex fix key2 string mode bug and some settings cannot saved bug',
        changeLog1:'2023.5.4 Updated to threekey_v5.0.hex, add setting it as a mouse',
        changeLog1_1:'How to update',
        changeLog2:'2023.4.25 Updated to threekey_v4.1.hex, which fixes the problem that when Windows presses the key immediately after connecting the keyboard, the key does not work',
        changeLog2_1:'How to update',
        videoText:'Video',
        keyTest:'Online Keyboard Testing Sites',
        mouseTest:'Online Mouse Testing Sites',
        openSource:'All software and hardware of the project are open source',
        backToIndex:'Back to topyuan.top',
        submit:'Save Parameters',
        browserErr:'Please use Chrome or Edge browser version 103 or above to access this page via https!',
        firmwareErr:'The currently connected 3-key keyboard is not the latest firmware and does not support mouse settings, please update!!<br/><br/>New version:<br/>5.0 Added mouse<br/>4.1 fix bugs<br/>4.0 Added a combination of up to 5 keys, press three keys at the same time to one new key<br/>',
        firmwareErrv5:'The currently connected 3-key keyboard is not the latest firmware and does not support press enter after string input settings, please update!!<br/><br/>New version:<br/>6.0 Added press enter after string input<br/>',
        firmwareErrv6:'The currently connected 3-key keyboard is not the latest firmware and does not support press mouse when long press, please update!!<br/><br/>New version:<br/>7.0 Added press mouse when long press<br/>',
        tip:'Notice',
        updateHelp:'Update tutorial',
        updateNo:'Not updated yet, return',
        redirecting:'Redirecting...please wait',
        connFirst:'Please connect the keyboard first',
        disconnect:'Disconnect',
        success:'Setting successful!',
        saveFailed:'Setting failed: data verification or saving did not pass. Please try again.',
        firmwareErr1:'The currently connected 3-key keyboard is not the latest firmware, please update!!<br/><br/>New version:<br/>5.0 Added mouse<br/>4.1 fix bugs<br/>4.0 Added a combination of up to 5 keys, press three keys at the same time to one new key<br/>',
        updateNo1:'Not updated for now, change the key first (redirect to the old version key change page)',
        conError1:'The port is occupied, the connection failed!',
        conError2:'Connection failed, reason:',
        conError3:'Disconnect failed! Please refresh the page!',
        howtoaddress:'https://topyuan.top/3key/howtoupdate',
        shortcutTitle:'Shortcut Keys',
        shortcutTip:'How to Configure',
        shortcutTipDesc:'Select a key → Set to "Combination Key" mode → Configure modifier keys (Ctrl/Win/Alt/Shift) + normal key below. E.g. Ctrl+C: select "Left Ctrl" as modifier, input "c" as key.',
        submitTipTitle:'Important',
        submitTipDesc:'After making changes, click the "Save Parameters" button at the bottom of the page to save settings to the device.',
        scGroupEdit:'Common Editing',
        scGroupWin:'Window & System',
        scGroupText:'Text & Rich Text',
        scGroupBrowser:'Browser',
        scGroupDev:'Developer Tools',
        scCopy:'Copy',
        scPaste:'Paste',
        scCut:'Cut',
        scUndo:'Undo',
        scRedo:'Redo',
        scSelectAll:'Select All',
        scSave:'Save',
        scFind:'Find',
        scReplace:'Replace',
        scPrint:'Print',
        scSwitchWin:'Switch Window',
        scDesktop:'Show Desktop',
        scExplorer:'Open File Explorer',
        scLock:'Lock Computer',
        scSettings:'Open Settings',
        scSearch:'Search',
        scCloseWin:'Close Window',
        scFullscreen:'Fullscreen',
        scScreenshot:'Screenshot (Full)',
        scSnipping:'Screenshot (Region)',
        scBold:'Bold',
        scItalic:'Italic',
        scUnderline:'Underline',
        scSelectWord:'Select Word',
        scHome:'Jump to Home',
        scEnd:'Jump to End',
        scDelete:'Delete',
        scNewTab:'New Tab',
        scCloseTab:'Close Tab',
        scSwitchTab:'Switch Tab',
        scReopenTab:'Reopen Closed Tab',
        scBookmark:'Add Bookmark',
        scRefresh:'Refresh',
        scHardRefresh:'Hard Refresh (Clear Cache)',
        scDevTools:'Developer Tools',
        scDevTools2:'DevTools (Alt)',
        scDebug:'Start Debugging',
        scTerminal:'Terminal',
        scCommandPalette:'Command Palette',
        scNewWin:'New Window',
        scGroupIDE:'IDE / Editor (Cursor/VS Code)',
        scDeleteLine:'Delete Line',
        scSelectNext:'Select Next Occurrence',
        scSelectAll:'Select All Occurrences',
        scMoveLine:'Move Line Up/Down',
        scComment:'Toggle Comment',
        scRename:'Rename Symbol',
        scGlobalSearch:'Search in Files',
        scExplorer:'File Explorer',
        scGoToLine:'Go to Line',
        scFormat:'Format Code',
        scSuggest:'Trigger Suggestion',
        scQuickFix:'Quick Fix',
        scToggleSidebar:'Toggle Sidebar',
        scGoToSymbol:'Go to Symbol',
        scGroupAIChat:'AI Chat',
        scAIChatSubmit:'Submit Prompt & Generate',
        scAIChatNewline:'Newline only (no send)',
        scAIChatClear:'Clear current chat context',
        scAIChatUndo:'Undo last AI generated code',
        scAIChatRetry:'Regenerate last answer (Retry)',
        scAIChatStop:'Stop AI generation',
        scGroupAICode:'Code AI Operations',
        scAICodeSidebar:'Open AI sidebar to explain/modify code',
        scAICodeInline:'Inline AI edit/complete/refactor',
        scAICodeSelectBlock:'Select entire function/code block',
        scAICodeAccept:'Accept AI single-line completion',
        scAICodeReject:'Reject AI completion & rollback',
        scAICodeRefactor:'Refactor selected code',
        scGroupAIFile:'File & Project AI',
        scAIFileCmdPalette:'Open global command palette',
        scAIFileOpen:'Open project file',
        scAIFileSearch:'Global search with AI',
        scAIFileExplorer:'Show/Hide file explorer',
        scAIFileTerminal:'Open terminal',
        scGroupAIWin:'Window & Session',
        scAIWinNew:'New blank chat window',
        scAIWinSwitch:'Switch between chat tabs',
        scAIWinClose:'Close current chat tab',
        scAIWinHistory:'Switch chat history context',
        scGroupZoom:'View Zoom',
        scZoomIn:'Zoom In (enlarge view/font)',
        scZoomOut:'Zoom Out (reduce view/font)',
        scZoomReset:'Reset Zoom (restore 100%)',
        scGroupOffice:'Office Software',
        scPasteValue:'Paste as Value (value only)',
        scPasteFormat:'Paste Format',
        scPasteLink:'Paste as Link',
        scFormulaBar:'Show/Hide Formula Bar',
        scPivotTable:'Create Pivot Table',
        scFillDown:'Fill Down',
        scGroupNav:'Quick Navigation',
        scGoBack:'Go Back (previous page)',
        scGoForward:'Go Forward (next page)',
        scQuickSave:'Save As',
        scRun:'Run (execute program/macro)',
        scTaskManager:'Open Task Manager',
        scCycleApps:'Cycle through open apps',
        scGroupZoomShort:'View Zoom',
        scGroupOfficeWord:'Word / WPS Writer',
        scWordNewDoc:'New blank document',
        scWordOpenDoc:'Open document',
        scWordSaveAs:'Save document as',
        scWordFindNext:'Find next occurrence',
        scWordGoToPage:'Go To (page/bookmark)',
        scWordInsertLink:'Insert hyperlink',
        scWordInsertPageBreak:'Insert page break',
        scWordSelectPara:'Select entire paragraph',
        scWord1_5Line:'Set 1.5 line spacing',
        scWordCenterAlign:'Center-align paragraph',
        scWordLeftAlign:'Left-align paragraph',
        scWordRightAlign:'Right-align paragraph',
        scWordJustifyAlign:'Justify paragraph',
        scWordBold:'Bold',
        scWordUnderline:'Underline',
        scWordItalic:'Italic',
        scGroupOfficeExcel:'Excel / WPS Spreadsheet',
        scExcelSumAuto:'Auto Sum (Alt+=)',
        scExcelFillRight:'Fill Right (Ctrl+R)',
        scExcelFillDown:'Fill Down (Ctrl+D)',
        scExcelPasteValue:'Paste as Value (value only)',
        scExcelPasteFormat:'Paste format (format painter copy)',
        scExcelInsertRow:'Insert entire row (Ctrl+Shift+=)',
        scExcelDeleteRow:'Delete entire row (Ctrl+-)',
        scExcelToggleFilter:'Toggle Filter on/off',
        scExcelGoToCell:'Go To (F5)',
        scExcelNameBox:'Go to Name Box',
        scExcelTodayDate:'Insert today date (Ctrl+;)',
        scExcelNowTime:'Insert current time (Ctrl+Shift+:)',
        scExcelSelectAllRegion:'Select current data region (Ctrl+A)',
        scExcelEditCell:'Edit cell (F2)',
        scExcelSwitchSheet:'Switch sheet (Ctrl+PageDown)',
        scExcelFreezePane:'Freeze Panes',
        scGroupOfficeCommon:'WPS / Office Common',
        scOfficeNewFile:'New file',
        scOfficeOpenFile:'Open file',
        scOfficeSave:'Save',
        scOfficeSaveAs:'Save As',
        scOfficePrint:'Print',
        scOfficeCloseFile:'Close current file',
        scOfficeUndo:'Undo',
        scOfficeRedo:'Redo / Repeat',
        scOfficeFind:'Find',
        scOfficeReplace:'Replace',
        scOfficeFullScreen:'Full screen',
        scOfficeZoomPlus:'Zoom in',
        scOfficeZoomMinus:'Zoom out',
        scOfficeZoom100:'Zoom to 100%',
    },
    keyConfig:{
        keyDes1:'Common key',
        keyDes2:'Function key',
        keyDes3:'Media key',
        keyDes4:'Combination key',
        keyDes5:'String',
        keyDes6:'Mouse',
        select:'Please choose',
        mix1:'Add a function key',
        mix2:'Add a common key',
        mix3:'Delete a combination key',
        mix4:'Reset the combination key',
        mix5:'Common combination keys',
        mixtip:'The following are common key combinations, which can be quickly set. If you don’t know what to set, you can check it out , I will update it irregularly.',
        mixcommon1:'Combination key',
        mixcommon2:'Description',
        mixcommon3:'Operate',
        set:'Set up',
        inputErr:'Input error',
        selectErr:'Select error',
        mixErr:'The combination key is at least 2 key combination!',
        mixErr1:'Combination key No.',
        mixErr2:' select error',
        mixErr3:' input error',
        textErr:'String cannot be empty',
        textErr1:'String input error, there is no such key',
        setErr:'Setting error',
        delErr:'Can no longer be deleted!',
        mixMaxErr:'Supports up to 5 key combinations!',
        mixAdd:'Please add function keys or common keys',
        mixMax5:'All the above key combinations, support up to 5 keys',
        holdTip:'Trigger continuously when long press',
        holdPressTip:'Press mouse when long press',
        doubleClick:'Double Click',
        stringEnter:'Press enter after input',
        move:'Moving distance',
        strong:'Intensity',
        normalKeyTip:'Supports numbers, letters, spaces and common symbols',
        normalKeyLowercaseHint:'Please type letters in lowercase (e.g. c, v) to work properly; uppercase may not work',
        mediaKeyTip:'Power, Sleep, Screen Saver etc. depend on system ACPI drivers and may not work on all PCs',
        mouses:['Left Click','Middle Click','Right Click','Random Move','Move Up','Move Down','Move Left','Move Right','Scroll Wheel Up','Scroll Wheel Down'],
        functionkeys:["Left Ctrl", "Left Shift", "Left Alt", "Left Win/Command", "Right Ctrl", "Right Shift", "Right Alt", "Right Win/Command", "Up", "Down", "Left", "Right", "Backspace", "Tab", "Enter", "ESC", "Insert", "Delete", "Page Up", "Page Down", "Home", "End", "Caps Lock", "Print Screen", "Scroll Lock", "Pause Break", "Num Lock", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "Menu", "/(num pad)", "*(num pad)", "-(num pad)", "+(num pad)", "Enter(num pad)", "1(num pad)", "2(num pad)", "3(num pad)", "4(num pad)", "5(num pad)", "6(num pad)", "7(num pad)", "8(num pad)", "9(num pad)", "0(num pad)", ".(num pad)"],
        mediakeys:["Next", "Previous", "Stop", "Play/Pause", "Pause", "Volume Mute", "Volume Up", "Volume Down","Brightness Up","Brightness Down","Open Music","Open Email","Open Calculator","Open Explorer","Open Browser","Browser Back","Browser forward","Browser Refresh","Browser bookmarks","Power", "Sleep", "Record", "Fast Forward", "Rewind","Screen Saver"],
        quickSetting:'Quick Setup',
        quickToggleHint:'Click a shortcut card above to configure',
        quickSearchPlaceholder:'Search shortcuts (e.g. Copy, Paste, Zoom, Ctrl+Shift+V...)',
        quickTip1:'💡 Tip: Click a card below to quickly set this key to the shortcut.',
        quickTip2:'Can\'t find the shortcut? Try setting it manually in "Combination Key" mode, or contact customer support!',
        quickSetSuccess:'Quickly set to: ',
        quickCategoryAll:'All',
        quickCategoryEdit:'Editing',
        quickCategorySystem:'System',
        quickCategoryBrowser:'Browser',
        quickCategoryOffice:'Office',
        quickCategoryIDE:'Dev',
        quickCategoryZoom:'Zoom',
        quickCategoryMedia:'Media',
        notSet:'Not Set',
        videoTutorial:'Video Tutorial'
    },
    rf24Pair:{
        entry:'2.4G Pairing',
        title:'2.4G Pairing',
        hint:'Plug in the receiver, open this page, put the keyboard into pairing mode, then search and pair.',
        warningTitle:'Do not pair a keyboard that is already working normally',
        warningDesc:'2.4G pairing is only for the first connection between a keyboard and receiver. Do not pair an already working keyboard again, or the connection may be interrupted and require re-pairing.',
        serialUnsupported:'This browser does not support Web Serial. Use Chrome / Edge or another Chromium-based browser.',
        connect:'Connect receiver',
        disconnect:'Disconnect',
        connected:'Receiver connected',
        receiverId:'Receiver ID',
        currentPair:'Current pairing',
        runState:'Status',
        protocolVersion:'Protocol version',
        paired:'Paired',
        unpaired:'Not paired',
        scanning:'Scanning…',
        search:'Search 2.4G devices',
        refresh:'Refresh',
        remaining:'Remaining',
        cancelSearch:'Cancel search',
        deviceId:'Device ID',
        model:'Model',
        actions:'Action',
        pair:'Pair',
        scanHint:'Scanning. Switch the target keyboard to 2.4G mode and hold KEY1 + KEY2 for about 3 seconds to enter pairing mode…',
        ledHint:'The red and green LEDs flashing rapidly together indicate pairing mode.',
        searchHint:'Click “Search 2.4G devices”. The receiver will scan for nearby keyboards of this series in pairing mode.',
        step1:'Confirm device',
        step2:'Switch address',
        step3:'Verify connection',
        successHint:'Pairing successful. The keyboard green LED flashes rapidly.',
        unpair:'Unpair',
        refreshState:'Refresh status',
        stateIdle:'Idle',
        stateScanning:'Scanning',
        statePairing:'Pairing',
        stateSuccess:'Paired',
        stateFailed:'Pairing failed',
        stateUnknown:'Unknown',
        timeout:'Receiver response timed out',
        connectFailed:'Connection failed: ',
        scanStarted:'Scan started. Put the target keyboard into pairing mode.',
        scanFailed:'Scan failed: ',
        pairRequestFailed:'Pairing request failed. Search again and retry.',
        selected:'Selected ',
        selectedSuffix:', switching communication address…',
        pairFailed:'Pairing failed: ',
        pairSuccess:'Pairing successful! The receiver switched to the new address; the keyboard green LED flashes rapidly.',
        pairRestore:'Pairing failed and the previous pairing was restored. Make sure the keyboard is still in pairing mode and retry.',
        cancelled:'Cancelled.',
        unpairWarning:'Unpairing will disconnect the current keyboard from the receiver. You must search and pair again to restore the 2.4G connection. Do not unpair unless necessary!',
        unpairTitle:'Warning: unpair 2.4G connection?',
        unpairConfirm:'Yes, unpair',
        unpairCancel:'Cancel',
        unpairCancelled:'Unpairing cancelled.',
        unpairDone:'Unpaired. Search and pair again.',
        unpairFailed:'Unpair failed: '
    }
}




// WEBPACK FOOTER //
// ./src/i18n/en.js